"use strict";

exports.__esModule = true;
exports["default"] = exports.LinkHelper = exports.Item = exports.HtmlContainer = exports.ChipWrapper = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styles = require("@qc-modules/styles");

var _propTypes = require("prop-types");

var _utils = require("../../utils");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _features = _interopRequireDefault(require("./features"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var LinkHelper = (0, _styledComponents["default"])(_primitives["default"].Flex).withConfig({
  displayName: "result-card__LinkHelper",
  componentId: "sc-13mo60c-0"
})([":hover &{box-shadow:0 2px 10px 0 rgba(74,90,117,0.08),0 20px 20px -12px rgba(74,90,117,0.24);}"]);
exports.LinkHelper = LinkHelper;
var ChipWrapper = (0, _styledComponents["default"])(_primitives["default"].Flex).withConfig({
  displayName: "result-card__ChipWrapper",
  componentId: "sc-13mo60c-1"
})(["box-sizing:content-box;"]);
exports.ChipWrapper = ChipWrapper;
var HtmlContainer = (0, _styledComponents["default"])(_primitives["default"].RawHtml).withConfig({
  displayName: "result-card__HtmlContainer",
  componentId: "sc-13mo60c-2"
})(["p{margin:0;}"]);
exports.HtmlContainer = HtmlContainer;
var Item = (0, _styledComponents["default"])(_primitives["default"].Flex).withConfig({
  displayName: "result-card__Item",
  componentId: "sc-13mo60c-3"
})(["", ";box-shadow:0 4px 16px 0 rgba(74,90,117,0.08),0 2px 4px 0 rgba(74,90,117,0.16);"], (0, _styles.transitionEase)("0.7s", ["box-shadow"]));
exports.Item = Item;
var propTypes = {
  /** Chip image node */
  chipImage: _propTypes.node,

  /** test id for Cypress */
  "data-test-id": _propTypes.string,

  /** max charCount for description */
  maxCharCount: _propTypes.number,

  /** main product description */
  productDescription: _propTypes.string,

  /** product features max 3 features */
  productFeatures: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    header: _propTypes.string,
    value: _propTypes.string
  })),

  /** url path for product details */
  productUrl: _propTypes.string,

  /** category product desctiption */
  shortDescription: _propTypes.string,

  /** title of the product */
  title: _propTypes.string,

  /** type of the product */
  type: _propTypes.string
};
var defaultProps = {
  maxCharCount: 164
};

var ResultCard = function ResultCard(_ref) {
  var chipImage = _ref.chipImage,
      dataTestId = _ref["data-test-id"],
      maxCharCount = _ref.maxCharCount,
      productDescription = _ref.productDescription,
      productFeatures = _ref.productFeatures,
      productUrl = _ref.productUrl,
      shortDescription = _ref.shortDescription,
      title = _ref.title,
      type = _ref.type;
  var description = shortDescription || productDescription;
  var truncatedDesc = description.length > maxCharCount ? (0, _utils.truncateHtml)(description, maxCharCount) : description;
  return /*#__PURE__*/_react["default"].createElement(LinkHelper, {
    alignItems: "flex-start",
    as: productUrl ? "a" : "div",
    borderRadius: 8,
    color: "white",
    "data-test-id": dataTestId,
    flexDirection: "column",
    href: productUrl,
    justifyContent: "flex-start",
    position: "relative",
    pt: 3,
    textDecoration: "none",
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(Item, {
    backgroundColor: "background",
    borderRadius: "12px",
    flexWrap: ["wrap", "wrap", "nowrap"],
    height: 1,
    position: "relative",
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    backgroundColor: ["gray-light", "gray-light", "transparent"],
    borderRadius: ["8px 8px 0 0", "8px 8px 0 0", "8px 0 0 8px"],
    flex: ["1 1 100%", "1 1 100%", "1 1 30%"],
    py: [3, 3, 0]
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    mx: "auto",
    px: [3, 3, 0],
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(ChipWrapper, {
    alignItems: "center",
    backgroundColor: ["transparent", "transparent", "gray-light"],
    borderRadius: ["none", "none", "8px 0 0 8px"],
    flex: "0 0 auto",
    justifyContent: "center",
    py: [0, 0, 0, 3],
    width: [60, 60, 122, 124]
  }, chipImage), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    alignItems: "flex-start",
    flexDirection: "column",
    justifyContent: "center",
    pl: [2, 5, 3],
    py: [0, 0, 0, 3]
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, {
    color: "blue",
    "data-test-id": "modules-result-card-title",
    fontSize: [3, 3, 3, 4],
    letterSpacing: "0.5px",
    lineHeight: 2,
    mb: 1
  }, title), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, {
    color: "body-grey",
    "data-test-id": "modules-result-card-type",
    fontSize: 1,
    letterSpacing: "0.5px",
    lineHeight: 1
  }, type)))), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    alignItems: "center",
    flex: ["1 1 100%", "1 1 100%", "1 1 30%"],
    mx: "auto",
    pl: 3,
    pr: [3, 3, 3, 4],
    py: 3
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, {
    color: "body-grey",
    "data-test-id": "modules-result-card-description",
    fontSize: 2,
    letterSpacing: "0.58px",
    lineHeight: 2,
    mb: [0],
    tag: "div"
  }, /*#__PURE__*/_react["default"].createElement(HtmlContainer, {
    html: truncatedDesc,
    tag: "div"
  }))), productFeatures ? /*#__PURE__*/_react["default"].createElement(_features["default"], {
    productFeatures: productFeatures
  }) : null));
};

ResultCard.propTypes = propTypes;
ResultCard.defaultProps = defaultProps;
ResultCard.displayName = "Modules.ResultCard";
var _default = ResultCard;
exports["default"] = _default;